import API from './API';

// -----------------------------------------------------------------------------
//  Agenzie — caricamento a batch
//
//  Le agenzie forniscono i driver. Le tre tariffe compenso (`hourly_rate`,
//  `km_refund_rate`, `night_compensation_rate`) alimentano il COD6.
//
//  ⚠️ I DRIVER NON ARRIVANO CON L'AGENZIA: nel controller `/agency` l'unico
//  join consentito è `areas`, non `drivers`. Il numero di driver si chiede
//  quindi a `/driver` con un conteggio per agenzia (`limit=1`, si legge solo
//  `total`). Sono chiamate piccole e parallele, limitate alle righe della
//  pagina.
//
//  Le `areas` restano lette solo per compatibilità: le zone stanno sui driver
//  come Regione→Provincia, non sull'agenzia.
// -----------------------------------------------------------------------------

const PAGE_SIZE = 25;

// Un driver operativo ha `is_alive = false`: il campo vale il contrario del suo
// nome. La spiegazione completa sta in driverAPI.js.
const IS_ALIVE_OPERATIVO = false;

function normalize(response, fallbackPage = 1) {
  const body = response?.data;
  if (Array.isArray(body)) {
    return { rows: body, total: body.length, page: fallbackPage, pageCount: 1 };
  }
  return {
    rows: body?.data ?? [],
    total: body?.total ?? 0,
    page: body?.page ?? fallbackPage,
    pageCount: body?.pageCount ?? 1,
  };
}

function searchClause(term) {
  const t = (term || '').trim();
  if (!t) return null;
  return {
    $or: [
      { company_name: { $contL: t } },
      { name: { $contL: t } },
      { surname: { $contL: t } },
      { mail: { $contL: t } },
      { telephone_number: { $contL: t } },
    ],
  };
}

export default {
  // ------------------------------------------------------------- LISTA ---
  getAgenciesPaged({ page = 1, limit = PAGE_SIZE, search = '', sort = '' } = {}) {
    const params = {
      page,
      limit,
      sort: sort || 'company_name,ASC',
    };
    const s = searchClause(search);
    if (s) params.s = JSON.stringify({ $and: [s] });
    return API.get('/agency', { params }).then((r) => normalize(r, page));
  },

  // ---------------------------------------------------------- DRIVER ---
  // Conteggio driver. Senza `agencyId` conta su tutte le agenzie (KPI di
  // testata); `onlyOperativi` restringe a quelli selezionabili per i booking.
  countDrivers({ agencyId = null, onlyOperativi = false } = {}) {
    const and = [{ is_deleted: { $ne: true } }];
    if (agencyId) and.push({ 'agency.id': { $eq: agencyId } });
    if (onlyOperativi) and.push({ is_alive: { $eq: IS_ALIVE_OPERATIVO } });
    const params = { page: 1, limit: 1, s: JSON.stringify({ $and: and }) };
    // il join serve solo quando si filtra sull'agenzia
    if (agencyId) params.join = ['agency'];
    return API.get('/driver', { params }).then((r) => normalize(r).total);
  },

  // Elenco driver dell'agenzia, con le zone strutturate per la colonna "Zona".
  getDriversOfAgency(agencyId) {
    return API.get('/driver', {
      params: {
        join: ['agency', 'provinces', 'provinces.region', 'areas'],
        s: JSON.stringify({
          $and: [
            { 'agency.id': { $eq: agencyId } },
            { is_deleted: { $ne: true } },
          ],
        }),
        sort: 'surname,ASC',
        limit: 200,
      },
    }).then((r) => normalize(r).rows);
  },

  // --------------------------------------------------------- DETTAGLIO ---
  getAgencyDetail(id) {
    return API.get(`/agency/${id}`);
  },

  isDriverOperativo(driver) {
    return driver?.is_alive === IS_ALIVE_OPERATIVO;
  },

  // -------------------------------------------------------- ELENCO COMPLETO ---
  getAgencies() {
    return API.get(`/agency`, {
      params: {
        join: ['areas'],
      },
    });
  },
  updateAgency(agency) {
    return API.patch('/agency/' + agency.id, agency);
  },

  addAgency(agency) {
    return API.post('/agency', agency);
  },
};
